import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { AddCartItemInput, addressCheckout, Coupon, paymentSetupCheckout, UpdateCartItemInput } from '../../inputs';
import { ActiveUserService, Checkout, CustomerLoginResponseDetail, SubmitResponse } from '@sgm-frontend/core';
import { HttpService } from './http.service';


@Injectable({
  providedIn: 'root'
})
export class CheckOutService extends HttpService<string | addressCheckout | paymentSetupCheckout, Checkout | SubmitResponse> {
  private readonly activeUserService = inject(ActiveUserService);

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'checkout');
  }
  getCheckout(): Observable<SubmitResponse> {
     return this.create().pipe(catchError((error) => of(error)));
  }
  selectAddressCheckout(inputId: addressCheckout): Observable<SubmitResponse> {
    return this.create(inputId, 'set-address');
  }
  setPaymentCheckout(inputId: paymentSetupCheckout): Observable<SubmitResponse> {
    return this.create(inputId, 'set-payment-method');
  }
  getPaymentMethodCheckout(): Observable<SubmitResponse> {
    return this.getAllGeneral(`payment-methods`).pipe(catchError((error) => of(error)));
  }
  getHandlingFee(cartAmount:number,method:string): Observable<SubmitResponse> {
    return this.getHandleFee(`handling-fee`,cartAmount,method).pipe(catchError((error) => of(error)));
  }

}